import { API, API_V1, PROVIDER, SYNC_IMAP} from "../constants";

export const getSyncImap = async ({userId, user, lexonToken}) => {
  const imap = PROVIDER.toLocaleLowerCase();
  const url = `${window.API_GATEWAY_ACC}/${API}/${API_V1}/${imap}/${SYNC_IMAP}/${userId}/Get/${user}`;
  const res = await fetch(url,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${lexonToken}`
      }
    });

  const syncsImap = await res.json();

  return syncsImap;
};

export const createSyncImap = ({userId, user, idClientLef, lexonToken}) => {
  const imap = PROVIDER.toLocaleLowerCase();
  let url = `${window.API_GATEWAY_ACC}/${API}/${API_V1}/${imap}/${SYNC_IMAP}/${userId}/CreateSyncImap/${user}`;

  url += `?idClientNavision=${idClientLef}`;

  try {
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${lexonToken}`
      },
      body: JSON.stringify({})
    })
      .then(res => res.json())
      .catch(err => {
        console.error('Error creating syncs imap', err);
      });
  } catch (err) {
    console.error('Error creating syncs imap', err);
  }
};

export const resetSyncsImap = ({userId, user, lexonToken}) => {
  const imap = PROVIDER.toLocaleLowerCase();
  let url = `${window.API_GATEWAY_ACC}/${API}/${API_V1}/${imap}/${SYNC_IMAP}/ResetSyncs`;

  url += `?lefebvreCredential=${userId}&email=${user}`;

  try {
    fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${lexonToken}`
      },
      body: JSON.stringify({})
    })
      .then(res => res.json())
      .catch(err => {
        // Log error but do not block the flow
        console.error('Error resetting syncs imap', err);
      });
  } catch (err) {
    // Log any synchronous errors (e.g., malformed URL)
    console.error('Error resetting syncs imap', err);
  }
};

export const deleteEmailElasticSearch = ({
  userId,
  account,
  lexonToken,
  folder,
  id,
}) => {
  const imap = PROVIDER.toLocaleLowerCase();
  let url = `${window.API_GATEWAY_ACC}/${API}/${API_V1}/${imap}/ElasticSearch/${userId}/DeleteMailsImap/${account}`;

  if (folder) {
    url += `?Folder=${folder}&Id=${id}`;
  }

  try {
    fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${lexonToken}`
      },
      body: JSON.stringify({})
    })
      .then(res => res.json())
      .catch(err => {
        console.error('Error deleting mail in ElasticSearch', err);
      });
  } catch (err) {
    console.error('Error deleting mail in ElasticSearch', err);
  }
};

export const insertMailElasticSearch = async ({
  userId,
  account,
  lexonToken,
  folder,
  id
}) => {
  const imap = PROVIDER.toLocaleLowerCase();
  let url = `${window.API_GATEWAY_ACC}/${API}/${API_V1}/${imap}/ElasticSearch/insert`;

  url += `?lefebvreCredential=${userId}&email=${account}&folder=${folder}&idExternal=${id}`;

  try {
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${lexonToken}`
      },
      body: JSON.stringify({})
    });

    const response = await res.json();

    return response;
  } catch (err) {
    console.error('Error inserting mail into ElasticSearch', err);
    throw err;
  }
};

export const updatedMailActionElasticSearch = ({
  userId,
  account,
  lexonToken,
  folder,
  id,
  dispatch,
  backendRequest,
  backendRequestCompleted
}) => {
  const imap = PROVIDER.toLocaleLowerCase();
  let url = `${window.API_GATEWAY_ACC}/${API}/${API_V1}/${imap}/ElasticSearch/update`;

  url += `?lefebvreCredential=${userId}&email=${account}&folder=${folder}&idExternal=${id}`;

  try {
    if (dispatch && backendRequest) {
      dispatch(backendRequest());
    }
    fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${lexonToken}`
      },
      body: JSON.stringify({})
    })
      .then(res => res.json())
      .catch(err => {
        console.error('Error updating mail action in ElasticSearch', err);
      })
      .finally(() => {
        if (dispatch && backendRequestCompleted) {
          dispatch(backendRequestCompleted());
        }
      });
  } catch (err) {
    console.error('Error updating mail action in ElasticSearch', err);
  }
};
